/**
 * Tracks Service - API client for elective/subject-track management
 * (school-wide track catalog, per-track subject assignment, and
 * per-student track enrollment).
 */
import api from '../utils/api';

const tracksService = {
  list: params => api.get('/api/tracks', { params }),
  create: data => api.post('/api/tracks', data),
  update: (id, data) => api.patch(`/api/tracks/${id}`, data),

  trackSubjects: trackId => api.get(`/api/tracks/${trackId}/subjects`),
  addSubject: (trackId, subjectId) => api.post(`/api/tracks/${trackId}/subjects`, { subject_id: subjectId }),
  removeSubject: (trackId, subjectId) => api.delete(`/api/tracks/${trackId}/subjects/${subjectId}`),

  trackStudents: trackId => api.get(`/api/tracks/${trackId}/students`),
  enrollStudent: (trackId, studentId, academicTermId) => api.post(`/api/tracks/${trackId}/students`, { student_id: studentId, academic_term_id: academicTermId }),
  removeStudentTrack: id => api.delete(`/api/student-tracks/${id}`),

  getStudentTrack: studentId => api.get(`/api/students/${studentId}/track`),
};

export default tracksService;
